import { useJson } from '@/hooks/useJson'

export interface ThemeSong {
  id: string
  title: string
  artists: string[]
  album_image_url: string | null
  ride_count: number
}

export interface ThemeArtist {
  id: string
  name: string
  image_url: string | null
  play_count: number
}

export interface MissingEssential {
  rank: number
  artist_name: string
  track_name: string
  artist_already_played: boolean
}

export interface InstructorThemeDetail {
  instructor: { id: string; name: string; image_url: string | null }
  theme: string
  ride_count: number
  top_songs: ThemeSong[]
  top_artists: ThemeArtist[]
  missing_essentials: MissingEssential[]
}

export function useInstructorThemeStats(instructorId: string | undefined, theme: string | undefined) {
  return useJson<InstructorThemeDetail>(
    instructorId && theme ? `/api/instructors/${instructorId}/themes/${encodeURIComponent(theme)}` : null,
    'Failed to load theme',
  )
}
